export function ParentDashboard() {
  return (
    <div className="stack">
      <div><h1>Progress Andi</h1><p className="muted">Ringkasan sederhana untuk orang tua.</p></div>
      <section className="grid grid--3">
        <div className="metric"><span>Hari belajar</span><strong>6/7</strong></div>
        <div className="metric"><span>Akurasi</span><strong>94%</strong></div>
        <div className="metric"><span>Worksheet</span><strong>31</strong></div>
      </section>
      <section className="card"><h2>Fokus berikutnya</h2><p>Listening masih membutuhkan latihan tambahan.</p></section>
    </div>
  );
}
